import { useQuery } from "@apollo/client";
import { GET_DASHBOARD_DATA } from "../graphql/dashboard";
import { useAuth } from "../lib/auth";
import { parseMoney } from "../lib/money";

export const useBalance = () => {
  const { user } = useAuth();
  const { data, loading, error, refetch } = useQuery(GET_DASHBOARD_DATA, {
    variables: { userId: user?.id },
    skip: !user?.id,
  });

  const orgBalance = data?.users_by_pk?.company?.organization_balance;
  const physicalCards = data?.physical_cards || [];
  const virtualCards = data?.virtual_cards || [];

  const totalOnPhysicalCards = physicalCards.reduce(
    (sum: number, c: { available_balance?: number }) =>
      sum + parseMoney(c.available_balance),
    0
  );

  const totalOnVirtualCards = virtualCards.reduce(
    (sum: number, c: { current_balance?: number }) =>
      sum + parseMoney(c.current_balance),
    0
  );

  const userBalance = totalOnPhysicalCards + totalOnVirtualCards;

  return {
    companyName: data?.users_by_pk?.company?.name || null,
    userBalance,
    availableBalance: orgBalance ? parseMoney(orgBalance.available_balance) : 0,
    totalAllocated: orgBalance ? parseMoney(orgBalance.total_allocated) : 0,
    totalLoadedToVirtualCards: orgBalance ? parseMoney(orgBalance.total_loaded_to_virtual_cards) : 0,
    totalOnCards: totalOnPhysicalCards,
    loading,
    error,
    refetch,
  };
};
